import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  dependantData: [],
  loading: false,
  dependantCount: 0,
  NoKData: [],
  NoKCount: 0,
  benefits: [],
  benefitCount: 0,
  specification: [],
  specificationCount: 0,
};

export const fetchDependant = createAsyncThunk(
  "dependantSlice/fetchDependant",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchDependant.action?ppId_id=${data?.ppId_id}&limit=${
          data?.limit ?? 10
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteDependant = createAsyncThunk(
  "dependantSlice/deleteDependant",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteDependant.action?dpId_id=${data?.dpId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const fetchNoK = createAsyncThunk(
  "dependantSlice/fetchNoK",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchNoK.action?ppId_id=${data?.ppId_id}&limit=${
          data?.limit ?? 10
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteNoK = createAsyncThunk(
  "dependantSlice/deleteNoK",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteNoK.action?nkId_id=${data?.nkId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const disconnectUser = createAsyncThunk(
  "dependantSlice/disconnectUser",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/usr/disconnectUser.action?usrId=${data?.usrId}`)
      .then((res) => res.data);
    return res;
  }
);

export const fetchEmployeeBenefits = createAsyncThunk(
  "dependantSlice/fetchEmployeeBenefits",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchEmployeeBenefits.action?ppId=${data?.ppId}&limit=${
          data?.limit ?? 10
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteEmployeeBenefit = createAsyncThunk(
  "dependantSlice/deleteEmployeeBenefit",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteEmployeeBenefit.action?ebId=${data?.ebId}`)
      .then((res) => res.data);
    return res;
  }
);

export const fetchEmployeeSpecification = createAsyncThunk(
  "dependantSlice/fetchEmployeeSpecification",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/fetchEmployeeSpecification.action?ppId=${data?.ppId}&limit=${
          data?.limit ?? 10
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteEmployeeSpecification = createAsyncThunk(
  "dependantSlice/deleteEmployeeSpecification",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteEmployeeSpecification.action?esId=${data?.esId}`)
      .then((res) => res.data);
    return res;
  }
);

export const dependantSlice = createSlice({
  name: "dependant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchDependant.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDependant.fulfilled, (state, action) => {
        state.loading = false;
        state.dependantData = action?.payload?.data?.result;
        state.dependantCount = action?.payload?.data?.total;
      })
      .addCase(fetchDependant.rejected, (state) => {
        state.loading = false;
        state.dependantData = [];
        state.dependantCount = 0;
      })

      .addCase(deleteDependant.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDependant.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteDependant.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchNoK.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNoK.fulfilled, (state, action) => {
        state.loading = false;
        state.NoKData = action?.payload?.data?.result;
        state.NoKCount = action?.payload?.data?.total;
      })
      .addCase(fetchNoK.rejected, (state) => {
        state.loading = false;
        state.NoKData = [];
        state.NoKCount = 0;
      })

      .addCase(deleteNoK.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteNoK.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteNoK.rejected, (state) => {
        state.loading = false;
      })

      .addCase(disconnectUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(disconnectUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(disconnectUser.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchEmployeeBenefits.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeBenefits.fulfilled, (state, action) => {
        state.loading = false;
        state.benefits = action?.payload?.data?.result;
        state.benefitCount = action?.payload?.data?.total;
      })
      .addCase(fetchEmployeeBenefits.rejected, (state) => {
        state.loading = false;
        state.benefits = [];
        state.benefitCount = 0;
      })

      .addCase(deleteEmployeeBenefit.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEmployeeBenefit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteEmployeeBenefit.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchEmployeeSpecification.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeSpecification.fulfilled, (state, action) => {
        state.loading = false;
        state.specification = action?.payload?.data?.result;
        state.specificationCount = action?.payload?.data?.total;
      })
      .addCase(fetchEmployeeSpecification.rejected, (state) => {
        state.loading = false;
        state.specification = [];
        state.specificationCount = 0;
      })

      .addCase(deleteEmployeeSpecification.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEmployeeSpecification.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteEmployeeSpecification.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default dependantSlice.reducer;
export const {
  setGraduateHeaderObj,
  graduateCleanUp,
  setGraduateListObj,
  setGraduateObj,
  setGradUpload,
} = dependantSlice.actions;
